module.exports = __webpack_public_path__ + "fonts/Rubik-300-hebrew10.bda074a.woff2";